import React from 'react';

import { MarkerTypes } from 'hooks/use-map/types';

export { MarkerTypes };

export interface IMarkerInput {
  id: string;
  type: MarkerTypes;
  location: CenterPoint;
  onPress?: () => void;
  title?: string;
  isSelected?: boolean;
  isFocused?: boolean;
  visible?: boolean;
}

export interface IMarker extends IMarkerInput {
  icon: React.ReactNode;
  preventMarkerPress: boolean;
}

export type PanToFn = (
  newPosition: {
    lat?: number | null;
    lng?: number | null;
  } | null,
  animationTime?: number,
  shouldUseActualZoom?: boolean,
  zoomToUse?: number
) => void;

export type FitAndCenterFromCoordsFn = (coordsArray: CenterPoint[]) => void;

export type CenterPoint = {
  lat: number;
  lng: number;
};

export type CenterPointExtended = {
  lat: number;
  lng: number;
  accuracy?: number;
  zoom?: number;
};

export interface IUseMapExtendedParam {
  startPosition?: CenterPointExtended | null;
  disableControls?: boolean;
  onDragEnd: () => void;
}

export type IUseMapExtendedResult = {
  actualMapCenterLatLng: CenterPointExtended;
  mapComponent: React.ReactNode;
  renderMarkers: (markers: React.ReactNode[] | void) => void;
  createMarker: (args: IMarker) => string | null | React.ReactNode;
  createMarkerList: (args: IMarker[]) => React.ReactNode[] | void;
  focusToPoint: PanToFn;
  focusToPoints: (coords: any[]) => void;
  getCurrentCenter: () => CenterPointExtended;
};

export type IUseMapExtended = (args: IUseMapExtendedParam) => IUseMapExtendedResult;

export type IUseMapProvider = (
  args: IUseMapExtendedParam,
  enabled?: boolean
) => IUseMapExtendedResult;
